// extracted by mini-css-extract-plugin
module.exports = {"copyright":"copyright-module--copyright--2bTKY","description":"copyright-module--description--3IJit","star":"copyright-module--star--3Jrs-"};